module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.support),
      expression: "support"
    }],
    ref: "btn",
    staticClass: "uploader-btn"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30c888d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/btn.vue
// module id = 73
// module chunks = 0